import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PatientInformationConstants } from '../../patientInformation/store/patientInformation.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setPatientMedications } from '../store/patientMedications.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* getPatientMedications(pcrDoc: IPcr) {
  const patientMedications = pcrDoc.patient?.patientMedications

  if (patientMedications && Object.keys(patientMedications).length !== 0) {
    yield put(setPatientMedications(patientMedications))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getPatientMedications, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getPatientMedications.saga.ts: ${e}`))
  }
}

export function* getPatientMedicationsSaga() {
  yield takeLatest([PatientInformationConstants.REFRESH_PATIENT_DATA], performWithMutexHOG, preloadPCR)
}
